export default {
  product_info: 'Produktinformationen',
  return: 'Zurück zu Optionen',
};
